import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import Select from 'react-select';
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";

function TVSidebarMenuAddUpdate() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();

  const baseURL = process.env.REACT_APP_Baseurl;
  const editApi = `${baseURL}/admin/tv_sidebar_menu/edit`;
  const createApi = `${baseURL}/admin/tv_sidebar_menu/create`;
  const storeApi = `${baseURL}/admin/tv_sidebar_menu/store`;
  const imageApi = globalImageUplaodAPI();
  const updateApi = `${baseURL}/admin/tv_sidebar_menu/update`;

  const navigate = useNavigate();
  const { id } = useParams();
  const combinedRef = useRef({});
  const [formDataError, setFormDataError] = useState({});
  const [formData, setFormData] = useState({
    sidebar_menu_name: "",
    sidebar_menu_status: 1,
    sidebar_menu_url: "site_url",
    sidebar_menu_select_url: "",
    sidebar_menu_custom_url: "",
    sidebar_menu_type: "",
    selected_sub_categories: [],
  });
  const [defaultOption, setDefaultOption] = useState({ state: "defaultOption" });
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState('');

  const multiSelectLabel = (array, valueKey, labelKey) =>
    Array.isArray(array) ? array.map((item) => ({ value: item[valueKey], label: item[labelKey] })) : [];

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.sidebar_menu_name) {
      setFormDataError((prev) => ({ ...prev, sidebar_menu_name: "TV Sidebar Menu Name cannot be empty." }));
      combinedRef.current['sidebar_menu_name']?.focus();
      formIsValid = false;
    }
    if (formData?.sidebar_menu_url === "site_url" && !formData?.sidebar_menu_select_url) {
      setFormDataError((prev) => ({ ...prev, sidebar_menu_select_url: "Site URL cannot be empty." }));
      combinedRef.current['sidebar_menu_select_url']?.focus();
      formIsValid = false;
    }
    if (formData?.sidebar_menu_url === "custom_url" && !formData?.sidebar_menu_custom_url) {
      setFormDataError((prev) => ({ ...prev, sidebar_menu_custom_url: "Custom URL cannot be empty." }));
      combinedRef.current['sidebar_menu_custom_url']?.focus();
      formIsValid = false;
    }
    return formIsValid;
  };

  const handleStore = (e) => {
    e.preventDefault();
    if (formValidation()) {
      if (!id) handleAdd();
      else handleUpdate();
    }
  };

  const handleFileUpload = async (recordId) => {
    try {
      const formDataAdd = new FormData();
      formDataAdd.append('sidebar_menu_image', imageFile);
      formDataAdd.append('id', recordId);
      formDataAdd.append('modelName', 'TvSideMenu');
      formDataAdd.append('imageFields[]', 'sidebar_menu_image');
      await fetchRequest({
        method: 'POST',
        url: imageApi,
        params: {},
        data: formDataAdd,
      });
      setImageFile(null);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const buildPayload = () => ({
    sidebar_menu_name: formData?.sidebar_menu_name,
    sidebar_menu_status: formData?.sidebar_menu_status,
    sidebar_menu_url: formData?.sidebar_menu_url,
    sidebar_menu_select_url: formData?.sidebar_menu_select_url,
    sidebar_menu_custom_url: formData?.sidebar_menu_custom_url,
    sidebar_menu_type: formData?.sidebar_menu_type,
    sidebar_menu_sub_categories: formData?.selected_sub_categories?.map((item) => item?.value).join(","),
  });

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: storeApi,
        params: {},
        data: buildPayload(),
      });
      if (response?.status) {
        if (imageFile) await handleFileUpload(response?.id);
        toast.success(response?.message);
        navigate("/tvmenu");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setShowOverlay(false);
    }
  };

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const response = await fetchRequest({
        method: 'PATCH',
        url: `${updateApi}/${id}`,
        params: {},
        data: buildPayload(),
      });
      if (response?.status) {
        if (imageFile) await handleFileUpload(id);
        toast.success(response?.message);
        setWithOutRefresh(!withOutRefresh);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setShowOverlay(false);
    }
  };

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(name === "sidebar_menu_type" ? { selected_sub_categories: [] } : {}),
      }));
    }
    setFormDataError((prev) => ({ ...prev, [name]: '' }));
    if (name === "sidebar_menu_url") {
      setFormDataError((prev) => ({ ...prev, sidebar_menu_select_url: '', sidebar_menu_custom_url: '' }));
    }
  };

  const handleMultiSelect = (selectedOptions, actionMeta) => {
    setFormData((prev) => ({ ...prev, [actionMeta.name]: selectedOptions }));
    setFormDataError((prev) => ({ ...prev, [actionMeta.name]: '' }));
  };

  const handleFileChange = (event) => {
    const { files } = event.target;
    if (files?.length > 0) {
      setImageFile(files[0]);
    }
    setFormDataError((prev) => ({ ...prev, sidebar_menu_image: '' }));
  };

  const handleClearSelectFile = () => {
    setImageFile(null);
  };

  useEffect(async () => {
    setLoading(true);
    if (id) {
      await fetchRequest({
        method: 'GET',
        url: `${editApi}/${id}`,
        params: {},
        data: {},
      })
        .then(response => {
          if (response?.status) {
            setFormData((prev) => ({
              ...prev,
              ...response?.tv_side_menus,
              selected_sub_categories: multiSelectLabel(response?.selected_sub_categories, 'id', 'name'),
            }));
            setDefaultOption((prev) => ({
              ...prev,
              categoryOption: response?.categories,
              video_categories: multiSelectLabel(response?.video_categories, 'id', 'name'),
              audios_categories: multiSelectLabel(response?.audios_categories, 'id', 'name'),
              live_categories: multiSelectLabel(response?.live_categories, 'id', 'name'),
              series_categories: multiSelectLabel(response?.series_categories, 'id', 'name'),
              languages: multiSelectLabel(response?.languages, 'id', 'name'),
            }));
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      await fetchRequest({
        method: 'GET',
        url: createApi,
        params: {},
        data: {},
      })
        .then(response => {
          if (response?.status) {
            setDefaultOption((prev) => ({
              ...prev,
              categoryOption: response?.categories,
              video_categories: multiSelectLabel(response?.video_categories, 'id', 'name'),
              audios_categories: multiSelectLabel(response?.audios_categories, 'id', 'name'),
              live_categories: multiSelectLabel(response?.live_categories, 'id', 'name'),
              series_categories: multiSelectLabel(response?.series_categories, 'id', 'name'),
              languages: multiSelectLabel(response?.languages, 'id', 'name'),
            }));
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [withOutRefresh]);

  if (loading) return <Defaultloadinggif className={"heightOnLoader"} />;

  return (
    <>
      {showOverlay && <Response_Processing />}
      <AdminBackNavigation path="/tvmenu" text="Back" />
      <AdminSaveHeader
        heading={id ? "Edit TV Sidebar Menu" : "Add TV Sidebar Menu"}
        saveText={id ? "Update TV Sidebar Menu" : "Save TV Sidebar Menu"}
        saveMethod={handleStore}
        loading={showOverlay}
      />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={id ? "Update TV Sidebar Menu" : "Create TV Sidebar Menu"} />
            <MessageLabel text="TV Sidebar Menu Name" className="mandatorySimple" />
            <AdminCustomInput
              type="text"
              name="sidebar_menu_name"
              value={formData?.sidebar_menu_name}
              onChange={handleInput}
              placeHolder={"Enter sidebar menu name"}
              ref={(el) => (combinedRef.current.sidebar_menu_name = el)}
              error={formDataError?.sidebar_menu_name}
            />

            <MessageLabel text="Menu Item URL Type" className="mandatorySimple" />
            <AdminCustomSelect
              name="sidebar_menu_url"
              value={formData?.sidebar_menu_url}
              onChange={handleInput}
              ref={(el) => (combinedRef.current.sidebar_menu_url = el)}
              options={[
                { name: "Site URL", value: "site_url" },
                { name: "Custom URL", value: "custom_url" },
              ]}
              error={formDataError?.sidebar_menu_url}
              defaultOptionName={""}
            />

            {formData?.sidebar_menu_url === "site_url" && (
              <>
                <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                <AdminCustomInput
                  type="text"
                  name="sidebar_menu_select_url"
                  value={formData?.sidebar_menu_select_url}
                  onChange={handleInput}
                  placeHolder={"Enter site URL"}
                  ref={(el) => (combinedRef.current.sidebar_menu_select_url = el)}
                  error={formDataError?.sidebar_menu_select_url}
                  appendText={`${process.env.REACT_APP_Baseurl_Frontend}/`}
                />
              </>
            )}

            {formData?.sidebar_menu_url === "custom_url" && (
              <>
                <MessageLabel text="Custom URL (ex. https || http)" className="mandatorySimple" />
                <AdminCustomInput
                  type="text"
                  name="sidebar_menu_custom_url"
                  value={formData?.sidebar_menu_custom_url}
                  onChange={handleInput}
                  placeHolder={"Enter custom URL"}
                  ref={(el) => (combinedRef.current.sidebar_menu_custom_url = el)}
                  error={formDataError?.sidebar_menu_custom_url}
                />
              </>
            )}

            <MessageLabel text="Dropdown for Category" />
            <AdminCustomSelect
              name="sidebar_menu_type"
              value={formData?.sidebar_menu_type}
              onChange={handleInput}
              ref={(el) => (combinedRef.current.sidebar_menu_type = el)}
              options={defaultOption?.categoryOption?.map((item) => ({ name: item?.name, value: item?.value }))}
              error={formDataError?.sidebar_menu_type}
              defaultOptionName={""}
            />

            <MessageLabel text="Dropdown for Sub Category" />
            <Select
              options={defaultOption?.[formData?.sidebar_menu_type]}
              isMulti
              name="selected_sub_categories"
              ref={(el) => (combinedRef.current.selected_sub_categories = el)}
              onChange={handleMultiSelect}
              value={formData?.selected_sub_categories}
              className={`${formDataError?.selected_sub_categories && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`}
              noOptionsMessage={() => `No data found for ${formData?.sidebar_menu_type?.replace(/_/g, " ") || "selected category"}`}
            />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="Status Settings" />
            <div className="d-flex justify-content-between mb-2">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"TV Sidebar Menu Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'sidebar_menu_status'} checked={formData?.sidebar_menu_status == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="TV Sidebar Menu Image" />
            <MessageLabel text="TV Sidebar Menu Image" />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={imageFile}
              uploadedImage={formData?.sidebar_menu_image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.sidebar_menu_image = el)}
              name="sidebar_menu_image"
              id={id}
              error={formDataError?.sidebar_menu_image}
            />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton
          saveMethod={handleStore}
          type="submit"
          saveText={id ? "Update TV Sidebar Menu" : "Save TV Sidebar Menu"}
          className="ms-auto"
          loading={showOverlay}
        />
      </FormContainer>
    </>
  );
}

export default TVSidebarMenuAddUpdate;
